<template>
    <div>
      <trademark-search-database-list></trademark-search-database-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  